var _style, _defs, _path, _path2, _path3, _polygon, _polygon2, _polygon3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPvSimplicidade = function SvgPvSimplicidade(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 491.3 491.3",
    style: {
      enableBackground: "new 0 0 491.3 491.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 491.3,
    height: 491.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.7,297.1c-30.9,0-56,25.1-56,56c0,30.9,25.1,56,56,56s56-25.1,56-56C341.7,322.2,316.5,297.1,285.7,297.1  M285.7,393.1c-22.1,0-40-17.9-40-40c0-22.1,17.9-40,40-40c22.1,0,40,17.9,40,40C325.7,375.2,307.7,393.1,285.7,393.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M381.7,153.1c-30.9,0-56,25.1-56,56c0,30.9,25.1,56,56,56s56-25.1,56-56C437.7,178.2,412.5,153.1,381.7,153.1  M381.7,249.1c-22.1,0-40-17.9-40-40c0-22.1,17.9-40,40-40c22.1,0,40,17.9,40,40C421.7,231.2,403.7,249.1,381.7,249.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.7,137.1c-30.9,0-56,25.1-56,56s25.1,56,56,56s56-25.1,56-56S132.5,137.1,101.7,137.1 M101.7,233.1 c-22.1,0-40-17.9-40-40s17.9-40,40-40s40,17.9,40,40S123.7,233.1,101.7,233.1"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "491.3,326.8 480,315.5 445.7,349.8 411.3,315.5 400,326.8 434.3,361.1 400,395.5 411.3,406.8  445.7,372.4 480,406.8 491.3,395.5 457,361.1  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "91.3,14.8 80,3.5 45.7,37.8 11.3,3.5 0,14.8 34.3,49.1 0,83.5 11.3,94.8 45.7,60.4 80,94.8 91.3,83.5  57,49.1  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "459.3,54.8 448,43.5 413.7,77.8 379.3,43.5 368,54.8 402.3,89.1 368,123.5 379.3,134.8 413.7,100.4  448,134.8 459.3,123.5 425,89.1  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.2,138l-48-24c-2.1-1-4.5-1.1-6.6-0.2c-2.1,0.9-3.8,2.7-4.5,4.9l-16,48l15.2,5.1l9.9-29.8 c0.8,1.5,1.5,2.9,2,4c4.6,8.5,6.2,18.1,5.6,32.1c-1.4,31.1-12.5,62.4-31.2,88.2c-3.7,5.1-8.5,10.1-13.4,15.2 c-14.7,15-33.4,25.7-53.3,37c-28.3,16.1-57.3,32.9-73.9,63.1c-6.6-2.7-13.8-4.2-21.3-4.2c-30.9,0-56,25.1-56,56 c0,30.9,25.1,56,56,56s56-25.1,56-56c0-17.6-8.2-33.3-20.9-43.6c14.4-26.6,40.4-41.6,68-57.3c19.9-11.4,40.6-23.1,56.8-39.7 c5.4-5.5,10.6-11,14.9-17c20.5-28.3,32.7-62.7,34.3-96.9c0.5-11.1,0.1-25.6-7-39.5l26.3,13.2L297.2,138z M101.7,433.1 c0,22.1-17.9,40-40,40s-40-17.9-40-40c0-22.1,17.9-40,40-40S101.7,411.1,101.7,433.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.4,2.2l-12.8,9.6c2.3,3,5.2,7.4,8.5,12.6l13.5-8.5C196.1,10.2,192.9,5.6,190.4,2.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.6,87l-14.5,6.8c2.6,5.6,4.7,10.4,6.1,14.1l15-5.6C243.6,98.2,241.4,93,238.6,87"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.1,29.8l-13.8,8.1c2.6,4.4,5.2,9,7.9,13.7l14-7.8C213.5,39,210.7,34.3,208.1,29.8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.9,58l-14.1,7.5c2.5,4.8,5,9.5,7.3,14.1l14.3-7.2C229.1,67.7,226.5,62.9,223.9,58"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPvSimplicidade, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pv-simplicidade.70b82176.svg";
export { ForwardRef as ReactComponent };